export const HOST_SEGMENT = 'host/';
